import { useMemo } from 'react';

import { useSafeState } from '../../hooks/use-safe-state';

export default function useLessonButtonTopEdge() {
  const [footerHeight, setFooterHeight] = useSafeState(0);
  const [viewHeight, setViewHeight] = useSafeState(0);
  const [containerHeight, setContainerHeight] = useSafeState(0);

  const topEdge = useMemo(() => {
    return containerHeight - viewHeight - footerHeight + 1;
  }, [footerHeight, viewHeight, containerHeight]);

  return {
    setFooterHeight,
    setViewHeight,
    setContainerHeight,
    topEdge,
  };
}
